import { FormattedText } from 'core/i18n';
import { isCountryPortugal } from 'utilities/multiLanguageHelper';
import { isMobile } from 'utilities/browser';
import MessageBox from 'components/commons/MessageBox/MessageBox';
import IconListCheck from 'assets/icons/icon-list-check.svg';
import React from 'react';

export const TransferHeaderContent = () => {
    return (
        <div className="transfer-content__header">
            <p className="text-heading--title">
                <FormattedText value="identification-transferIdentification" />
            </p>
            <p className="text-regular--title">
                {isCountryPortugal() ? (
                    <FormattedText value="identification-nameValidationByAccount" />
                ) : (
                    <FormattedText value="identification-transferMethodDuration" />
                )}
            </p>

            {!isMobile() && (
                <MessageBox
                    boxColor="blue"
                    iconColor="info-blue"
                    titleText={<FormattedText value="identification-keepInMind" />}
                    contentText={<FormattedText value="identification-youWillContinueOnMobile" />}
                />
            )}
            <p className="text-heading--subtitle">
                <FormattedText value="identification-whatDoYouNeed" />
            </p>
            <div className="requirements">
                <img src={IconListCheck} alt="success" className="requirements-icon" />
                <div className="col-sm-11">
                    <p className="text-regular">
                        <span className="text-bold">
                            <FormattedText value="identification-headlineEUAccount" />
                        </span>
                    </p>
                    {isCountryPortugal() && (
                        <p className="text-regular">
                            <FormattedText value="identification-shareAccountTransferAdvise" />
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};
